import { lazyWithPreload } from '@shared/utils/lazyWithPreload';

// Route-level lazy auth pages that other pages warm up before navigating.
// Kept out of app/routes so the login page can preload them without importing
// the router (which imports the login page).
export const ForgotPassword = lazyWithPreload(() =>
  import('./authRoutes').then((mod) => ({
    default: mod.ForgotPassword,
  }))
);
